<template>
  <div class="kt-section__content animated fadeIn">
    <div class="pb-5 row">
      <button class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon" title="Regresar"
              v-on:click="$emit('regresar')">
        <i class="la la-arrow-left"></i>
      </button>
      <div class="col">
        <img :src="pasarela.logo" class="img-fluid" :alt="'logo '+pasarela.name">
      </div>
      <div class="col">
        <div class="text-right">
          <button class="btn btn-info btn-sm" type="button" v-b-modal.modal-p2p>
            <small>Preguntas frecuentes</small>
          </button>
        </div>
      </div>
    </div>
    <div class="pt-3 pb-5">
      <div class="pt-3">
        <h5 class="text-primary linea2">Datos del cliente:</h5>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Nombre</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt1 }} {{ persona.dt2 }} {{ persona.dt3 }} {{ persona.dt4 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Identificación</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt9 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Teléfono celular</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt20 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Correo electrónico</b>
          </div>
          <div class="col-md-8 col-12">
            {{ persona.dt21 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-12">
            <b>Moneda</b>
          </div>
          <div class="col-md-8 col-12">
            {{ moneda.texto }}
          </div>
        </div>
      </div>
      <div class="pt-3">
        <div class="pt-3">
          <h5 class="text-primary linea2">
            Datos de pago
          </h5>
          <div class="row">
            <div class="col-12 pb-2 pt-2 mb-3">
              <b-form-radio-group
                  v-model="formulario.titular"
                  name="tipo"
              >
                <b-form-radio :value="false">Pagar con datos del titular</b-form-radio>
                <b-form-radio :value="true">Pagar con datos de terceros</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
          <template v-if="formulario.titular">
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label><i class="fa fa-asterisk text-danger"></i>Tipo de documento de identidad</label>
                  <combo-box v-model="formulario.tipo" :opciones="tipoDocumento" name="tipo de documento"
                             v-validate="{required:true,obj:true}"></combo-box>
                  <span class="form-text text-danger">{{ errors.first('tipo de documento') }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label for="númerodd"><i class="fa fa-asterisk text-danger"></i>Número de documento</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="formulario.numero"
                      name="número de documento"
                      id="númerodd"
                      min="1" step="any"
                      v-validate="{decimal:2,required:true,min_value:1}"
                  >
                  <span class="form-text text-danger">{{ errors.first("número de documento") }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label><i class="fa fa-asterisk text-danger"></i>Apellidos</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="formulario.apellido"
                      name="apellidos"
                      v-validate="{required:true,alpha_spaces:true}"
                  >
                  <span class="form-text text-danger">{{ errors.first("apellidos") }}</span>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label><i class="fa fa-asterisk text-danger"></i>Nombres</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="formulario.nombre"
                      name="nombres"
                      v-validate="{required:true,alpha_spaces:true}"
                  >
                  <span class="form-text text-danger">{{ errors.first("nombres") }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label><i class="fa fa-asterisk text-danger"></i>Celular</label>
                  <input
                      type="tel"
                      class="form-control"
                      v-model="formulario.celular"
                      name="celular"
                      v-validate="{required:true,...valTelf.celular}"
                  >
                  <span class="form-text text-danger">{{ errors.first("celular") }}</span>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-group">
                  <label><i class="fa fa-asterisk text-danger"></i>Email</label>
                  <input
                      type="email"
                      class="form-control"
                      v-model="formulario.email"
                      name="email"
                      v-validate="{required:true,email:true}"
                  >
                  <span class="form-text text-danger">{{ errors.first("email") }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="pt-3">
        <h5 class="text-primary linea2">Últimos pagos realizados
          <button type="button" class="btn btn-outline-hover-success btn-sm btn-icon btn-circle"
                  :disabled="cargando"
                  v-on:click="consultaLista"><i class="flaticon-refresh"></i></button>
        </h5>
        <div class="table-responsive tabla-alto-scroll">
          <table class="table table-sm">
            <thead>
            <tr>
              <th>Referencia</th>
              <th>Fecha</th>
              <th class="text-right">Valor</th>
              <th class="text-center">Estado</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="cargando">
              <tr>
                <td colspan="5" class="text-muted text-center">
                  <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Cargando
                </td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(i,ii) in lista" :key="ii">
                <th scope="row">{{ i.dt2 }}</th>
                <td>{{ fechaLarga(i.ddt2) }}</td>
                <td class="text-right precio-syb">{{ punto(i.ndt2) }}</td>
                <td class="text-center">
                  <span class="badge" :class="colorStado(i)">{{ i.dt10 }}</span>
                </td>
              </tr>
              <tr v-if="lista.length===0">
                <td colspan="5" class="text-muted text-center">
                  No existen pagos
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="linea2 pt-4 pb-4"></div>
      <div class="mt-4 ">
        <form @submit.prevent="validar" class="row justify-content-center">
          <div class="col-7 text-center">
            Ingrese monto a pagar con tarjeta de crédito
          </div>
          <div class="col-md-8 col-12">
            <div class="kt-input-icon kt-input-icon--left">
              <input
                  type="number"
                  class="form-control form-control-lg danger"
                  name="valor"
                  v-model="formulario.valor"
                  v-validate="{required:true,decimal:2,max_value:maximo,min_value:0}"
                  min="1"
                  step="any"
                  :disabled="cargandoBtn"
                  ref="valor"
              />
              <span class="kt-input-icon__icon kt-input-icon__icon--left">
								<span><i class="la la-dollar "></i></span>
							</span>
            </div>
            <span class="form-text text-danger">{{ errors.first('valor') }}</span>
          </div>
          <div class="col-12 pt-4">
            <button type="submit" class="btn btn-pill btn-block btn-primary"
                    :class="cargandoBtn && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'"
                    :disabled="cargandoBtn">Ir a proceso de pago
            </button>
          </div>
        </form>
      </div>
    </div>
    <b-modal id="modal-p2p" ref="privacy" size="md" hide-footer title="Preguntas Frecuentes" body-class="m-1 p-0">
      <modal-placetopay :data="pasarela"></modal-placetopay>
    </b-modal>
  </div>
</template>

<script>
import {pagos, persona, negociacion, catalogos} from "../../../../servicios";
import modalPlacetopay from "../../../../componentes/modal-placetopay";
import comboBox from "@/componentes/comboBox";
import constantes from "../../../../constantes";
import _ from 'lodash';

export default {
  name: "placeToPay",
  props: {
    pasarela: {
      type: Object
    },
    persona: {
      type: Object,
      required: true,
    },
    tipo: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    lista: [],
    cargando: true,
    cargandoBtn: false,
    alerta: false,
    formulario: {
      nombre: null,
      apellido: null,
      numero: null,
      tipo: {id: null},
      titular: false,
      valor: null
    },
    tipoDocumento: [],
    moneda: constantes.Constantes.enumeraciones.moneda,
    valTelf: constantes.Constantes.validacion,
  }),
  components: {
    modalPlacetopay,
    comboBox,
  },
  computed: {
    maximo: function () {
      return (this.$store.getters.getCotizacion.ndt13).toFixed(2);
    }
  },
  methods: {
    fechaLarga: (fechaIso) => constantes.funciones.formatoFechaL(fechaIso),
    punto: (n) => constantes.funciones.puntoMilesDecimal(n),
    colorStado: (obj) => constantes.funciones.colorEstado(obj.dt10),
    consultaLista: function () {
      this.cargando = true;
      this.consultaPagos();
    },
    consultaPagos: _.debounce(function () {
      this.alerta = false;
      pagos.actualizarEstados(this.pasarela).then(() => {
        pagos.consultaPagos(this.pasarela).then(r => r.data).then(response => {
          negociacion.busquedaId();
          this.lista = response;
          response.map(item => {
            if (item.dt10 === 'PENDIENTE')
              this.alerta = item;
          });
          this.cargando = false;
        });
      });
    }, 1000),
    validar: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let vm = this;
          if (this.alerta) {
            this.$swal({
              html: `<small>Estimado cliente, tiene pagos pedientes por procesar.</small><br><br><b>¿Desea continuar?</b>`,
              type: 'warning',
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: true,
              confirmButtonText: 'Si',
              confirmButtonAriaLabel: 'Si',
              cancelButtonText: 'No',
              cancelButtonAriaLabel: 'No',
            }).then(function (valor) {
              if (valor.value) {
                vm.cargandoBtn = true;
                vm.enviarPago2();
              }
            });
          } else {
            this.cargandoBtn = true;
            this.enviarPago2();
          }
        } else {
          this.$toast.show(`Completa el formulario`);
        }
      });
    },
    enviarPago2: _.debounce(function () {
      const cotizacion = this.$store.getters.getCotizacion;
      persona.validarDatos().then(r => r.data).then(validacion => {
        this.redirigir(validacion.bdt1 && cotizacion.bdt1, this.valor);
      }).catch(() => {
        this.redirigir(false, this.valor);
      });
    }, 2000),
    consultarTipoPersona: function () {
      catalogos.tipoDocumento().then((response) => {
        response.data.forEach(i=>{
          if(!i.bdt1){
            this.tipoDocumento.push(i);
          }
        })
      });
    },
    redirigir: function (tipo) {
      const cotizacion = this.$store.getters.getCotizacion;
      if (tipo) {
        pagos.crearPago(this.formulario, this.pasarela, this.tipo).then(r => r.data).then(pago => {
          this.$toast.show(`Redirigiendo`);
          window.location = pago.dt1;
        }).catch(() => {
          setTimeout(() => {
            this.cargandoBtn = false;
          }, 2000);
        });
      } else {
        this.$store.commit("setPago",
            {
              tipo: this.tipo,
              pasarela: this.pasarela,
              valor: this.formulario
            }
        );
        this.$router.push({name: cotizacion.bdt4 ? 'compras.credito.solicitud' : 'compras.contado.licitud'});
      }
    }
  },
  mounted() {
    this.consultaLista();
    //this.valor=this.$store.getters.getValorC;
    this.$refs.valor.focus();
  },
  created() {
    this.consultarTipoPersona();
  }
}
</script>

<style scoped>
.form-control-lg {
  text-align: center;
}

label {
  margin: 0;
}

</style>
